import React, { useState, useEffect } from 'react';
import { getAllBlogs } from '../../common/blogStore';
import { BlogListItem, BlogSidebar } from './BlogParts';

function Blogs() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    getAllBlogs()
      .then(setBlogs)
      .catch((err) => console.error(err));
  }, []);

  return (
    <section className="blog-main section-padding">
      <div className="container">
        <div className="row lg-marg justify-content-around">
          <div className="col-lg-8">
            <div className="md-mb80">
              {blogs.map((blog, i) => (
                <BlogListItem
                  key={blog.id}
                  blog={blog}
                  isLast={i === blogs.length - 1}
                />
              ))}
              {blogs.length === 0 && (
                <p className="p-color">Henüz blog yazısı bulunmuyor.</p>
              )}
            </div>
          </div>
          <div className="col-lg-4">
            <BlogSidebar blogs={blogs} />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Blogs;
